import React, { useState, useEffect, useContext } from 'react'
import { Route, Routes, useNavigate, Navigate, redirect, useLocation } from "react-router-dom"
import { roleContext } from './context/RoleContext.js';
import { authContext } from './context/AuthContext.js'
import Authorization from './pages/Authorization.jsx'
import Sidebar from './pages/Sidebar';
import Notfound from './pages/Notfound.jsx';
import Header from './pages/Header';
import ResetPassword from './pages/ResetPassword.jsx';
import ResetPasswordAccount from './pages/ResetPasswordAccount.jsx';
import PrivateOutlet from './components/Authorization/PrivateOutlet';
import CircularProgress from '@mui/material/CircularProgress';

// import ChangePassword from './components/Account/ChangePassword.jsx';
// import UserProfile from './components/Account/AccountPages/UserProfile.jsx';
import NewAccountResetPassword from './pages/NewAccountResetPassword.jsx';
import TimeSheetLanding from './pages/TimeSheetLanding.jsx';
import ItemSaleLanding from './pages/ItemSaleLanding.jsx';
import CashierReport from './components/CashierReport/CashierReport.jsx';
import AllLocationSales from './components/ItemSales/AllLocationSales.jsx';


export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust the width as per your mobile breakpoint
  const location = useLocation();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Add event listener on mount
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const nav = useNavigate()

  // const { setLocationAccess, locationAccess } = useContext(LocationContext)
  const [key, setKey] = useState(false);

  const { user, isAuthenticated, isLoading, userRole, userName } = useContext(authContext)


  if (isLoading) {
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", position: "relative", top: "40%" }}>
        <CircularProgress />
        <p style={{ marginTop: "8px", color: "#1976d2", width: "max-content" }}>Loading...</p>
      </div>
    )
  }

  return (
    <div className="app">
      <div className='row' style={{ flexDirection: 'column' }}>
        {/* {isAuthenticated && <Header logout={logout} usrName={usrName} reload={() => setKey(!key)} usrRole={userRole} />} */}
        {isAuthenticated && (
          <Header
            usrName={userName}
            reload={() => setKey(!key)}
            usrRole={userRole}
          />
        )}
      </div>

      <div className='row' style={{ flexDirection: 'column', height: '100vh' }}>
        <roleContext.Provider value={userRole}>

          <div className="main-content">

            {isAuthenticated &&
              <Sidebar usrRole={userRole} isMobile={isMobile} />
            }
            <div className={`${location.pathname === '/login' ? 'content-login' : 'content'}`} >
              {/* <div> */}
              <Routes>

                <Route exact path='/' element={<PrivateOutlet isAllowed={!!isAuthenticated} />} >
                  <Route index element={<Navigate to="/time-sheet-landing" replace />} />
                  <Route path="/time-sheet-landing" element={<TimeSheetLanding />} />
                  <Route path="/item-sales" element={<ItemSaleLanding />} />
                  <Route path="/cashier-sales" element={<CashierReport />} />
                </Route>

                <Route exact path='/' element={<PrivateOutlet isAllowed={!!isAuthenticated && userRole === 'SuperAdmin'} />} >
                  <Route index element={<Navigate to="/time-sheet-landing" replace />} />
                  <Route path="/time-sheet-landing" element={<TimeSheetLanding />} />
                  <Route path="/item-sales" element={<ItemSaleLanding />} />
                  <Route path="/cashier-sales" element={<CashierReport />} />
                  <Route path="/all-store-sales" element={<AllLocationSales />} />
                </Route>

                <Route path="/login" element={<Authorization />} />
                <Route path="/reset-password/account/:tokenKey" element={<ResetPasswordAccount />} />
                <Route path="/reset-password/new-account/:tokenKey" element={<NewAccountResetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                <Route path="/signup" element={<Authorization />} />
                <Route path="*" element={<Notfound />} />
              </Routes>

            </div>

            {/* </div> */}
          </div>

        </roleContext.Provider>

      </div>
      <div >
      </div >
    </div >

  );
}
